<template>
  <ImportCore
    :resolver="managerImportResolver"
    :company-source-resolver="managerCompanySourcesModel"
    :company-id="companyId"
  />
</template>

<script lang="ts" setup>
  // Types
  import type { IImportModel } from '~/shared/import/types';
  import type { ICompanySourceModel } from '~/shared/source/types';

  // Services
  import { ManagerImportResolver } from '~/modules/manager/company/import/services/manager-import-resolver.service';

  // Models
  import { ManagerCompanySourcesModel } from '~/modules/manager/company/sources/models/manager-company-sources.model';

  // Components
  import ImportCore from '~/shared/import/core/ImportCore.vue';

  const props = defineProps({
    companyId: {
      type: Number,
      required: true,
    },
  });

  const managerImportResolver: IImportModel = new ManagerImportResolver(props.companyId);
  const managerCompanySourcesModel: ICompanySourceModel = new ManagerCompanySourcesModel();
</script>
